module.exports = __webpack_public_path__ + "static/media/mid.3f703e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/lucky-chiken/mid.png
// module id = 2468
// module chunks = 7